export const medicalConditions = [
  'Diabetes',
  'Hypertension',
  'Asthma',
  'Heart Disease',
  'Thyroid Disorder',
  'Arthritis',
  'Depression',
  'Anxiety',
  'Allergies',
  'Epilepsy',
  'Chronic Back Pain',
  'Cancer',
  'None',
];

export const surgeryOptions = [
  "Laparoscopic Appendectomy",
  "Inguinal Hernia Repair",
  "Cesarean Section (C-section)",
  "Gallbladder Removal (Cholecystectomy)",
  "Knee Replacement",
  "Coronary Artery Bypass",
  "Hip Replacement",
  "Tonsillectomy",
  "Hysterectomy",
  "Cataract Surgery",
];

export const medicationOptions = [
  'Paracetamol',
  'Metformin',
  'Amlodipine',
  'Telmisartan',
  'Insulin',
  'Thyronorm',
  'Aspirin',
  'Clopidogrel',
  'Vitamin D3',
  'Calcium',
  'Ibuprofen',
  'Rantac',
  'Gelusil',
  'Salbutamol Inhaler',
  'None'
];

export const benefitsOptions = [
  "Relieves pain and improves quality of life.",
  "Removes source of infection or disease.",
  "Restores normal function and mobility.",
  "Improves long-term prognosis and prevents complications."
];

export const risksOptions = [
  "Infection, bleeding, or reaction to anesthesia.",
  "Damage to nearby organs or tissues.",
  "Post-operative pain or delayed healing.",
  "Scarring or need for additional procedures."
];

export const alternativesOptions = [
  "Medical management with medication.",
  "Physical therapy or lifestyle changes.",
  "Watchful waiting with regular monitoring.",
  "No treatment at this time."
];

export const pastSurgeriesOptions = [
  'Appendectomy',
  'Cholecystectomy',
  'Cesarean Section',
  'Coronary Artery Bypass',
  'Hysterectomy',
  'Knee Replacement',
];

export const anesthesiaOptions = [
  'General Anesthesia',
  'Regional Anesthesia (Spinal/Epidural)',
  'Local Anesthesia',
  'MAC (Monitored Anesthesia Care)',
];
